import { useRef } from "react";
import useVimeo from "../hooks/useVimeo";
import useYouTube from "../hooks/useYoutube";

export type VimeoEmbedProps = {
  videoId: string;
  videoHash?: string;
  className?: string;
};

export function VimeoEmbed(props: VimeoEmbedProps) {
  const videoContainerRef = useRef<HTMLDivElement>(null);

  useVimeo({
    videoId: props.videoId,
    videoHash: props.videoHash,
    videoContainerRef: videoContainerRef,
  });

  return (
    <div
      className="w-full overflow-hidden rounded-3xl"
      ref={videoContainerRef}
    />
  );
}

export type YouTubeEmbedProps = {
  videoId: string;
};

export function YouTubeEmbed(props: VimeoEmbedProps) {
  const videoContainerRef = useRef<HTMLDivElement>(null);

  useYouTube({
    videoId: props.videoId,
    videoContainerRef: videoContainerRef,
  });

  return (
    <div className="aspect-video w-full">
      <div className="h-full w-full rounded-3xl" ref={videoContainerRef} />
    </div>
  );
}
